module.exports = __webpack_public_path__ + "img/arrow_right.a143080a.svg";